import { SentryService } from "@callcenter/services"

import { userAccountModel } from "./user-account"

SentryService.setStoreInstances([userAccountModel], "header")
